export const PERSONAL_DATA_FORM_MESSAGE_VALIDATION_RULES = {
	configMessage: {
	  isRequired: {
		value: true,
	  },
	},
  };
  
  export const PERSONAL_DATA_FORM_POPUP_VALIDATION_RULES = {
	infoTitle: { 
	  isRequired: { 
		value: true,
	  },
	  maxLength: {
		value: 128,
	  },
	},
	infoMessage: {
	  isRequired: {
		value: true,
	  },
	},
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/personal-data-configuration/PersonalDataFormValidationRules.js